import { render, staticRenderFns } from "./SelectTheme.vue?vue&type=template&id=1db16f09&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SelectTheme.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/SelectTheme.vue
// module id = 2433
// module chunks = 1